import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './de.json';
import en from './en.json';
import fr from './fr.json';

/*
 * German is the primary UI language, English the fallback for all
 * other browser languages. The detector caches an explicit choice in
 * localStorage (key `i18nextLng`), which a language switcher can use
 * later; without it the browser language decides.
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
    },
    supportedLngs: ['de', 'en', 'fr'],
    /* map regional variants like de-DE onto de */
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',
    interpolation: {
      /* React already escapes rendered strings */
      escapeValue: false,
    },
  });

export { i18n };
